module.exports = __webpack_public_path__ + "static/terms_of_service_and_use_of_the_bank_card_of_bank_131-51577907b01752baa9a7c25ec08f1761.pdf";